import moment from 'moment';

export const formatMessageTime = (timestamp) => {
  const now = moment();
  const messageTime =  moment.utc(timestamp).local();
  const diffInDays = now.diff(messageTime, 'days');

  if (diffInDays === 0) {
    // Show "x minutes ago", "a few seconds ago"
    return `${messageTime.format('MMM D, YYYY h:mm a')} (${messageTime.fromNow()})`; // e.g. "5 minutes ago"
  } else if (diffInDays <= 7) {
    // Show "x days ago"
    return `${messageTime.format('MMM D, YYYY h:mm a')} (${diffInDays} day${diffInDays > 1 ? 's' : ''} ago)`;
  } else {
    // Show date
    return messageTime.format('MMM D, YYYY h:mm a'); // e.g. "Mar 28, 2025"
  }
};